import { Component, ElementRef, Input, EventEmitter, OnInit, Output, Renderer2, ViewChild,ChangeDetectorRef  } from '@angular/core';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { faAngleDown, faAngleUp,faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import * as commonConstant from '../../../../../services/common.constant';
import { Router, ActivatedRoute } from '@angular/router';
import { NotificationService } from './../../../../../../../src/app/notification.service';  
import { NgxSpinnerService } from 'ngx-spinner';
import { TeamService } from '../../../../../services/Teams/team.service';
import { UserService } from '../../../../../services/Users/manage-user/user.service';
import { DatatransferService } from 'src/app/services/DataTransfer/datatransfer.service';
import { ClientService } from 'src/app/services/Client/client.service';
import { ModulesService } from 'src/app/services/Authetication/menu-permission/modules.service';
import { MatSelect,MatSelectChange  } from '@angular/material/select';
import { FormControl, FormGroup,FormBuilder,FormArray } from '@angular/forms';
import * as moment from 'moment';
import { concatMap, Observable, of } from 'rxjs';

@Component({
  selector: 'app-teamlist',
  templateUrl: './teamlist.component.html',
  styleUrls: ['./teamlist.component.css']
})
export class TeamlistComponent implements OnInit {
  @Input() inReportTypeClient: any;
  @Input() inPriorityClient: any;
  @Input() inTurnaroundTimeClient: any;
  @Input() stReportTypesClient: any;
  @Input() flgIsEmailOnPublishClient: boolean = false;
  @Output() loaded = new EventEmitter<void>();
  teamMembers: any;
  @ViewChild('teamMemberSelect') teamMemberSelect !: ElementRef;
  @ViewChild("checkAllSelectOptions", { read: ElementRef }) checkAllSelectOptions!: ElementRef;
  teamMemberForm!: FormGroup;
  teamForms: FormGroup[] = [];
  filterTeamMember: any = [];
  isSelectedAll:boolean = false;
  teamMembersData: any;
  selectedTeamMembers: any[]=[];
  selectedMembers: any[]=[];
  deselectedUserIds: any[]=[];
  faAngleDown = faAngleDown;
  faAngleUp = faAngleUp;
  faPlusCircle = faPlusCircle;
  teamResponse: any = [];
  combinedTeamData: any = [];
  listingBodyParameter: any;
  listingBodyParameterforUserListing : any
  perPageArray:any[] = [];
  totalTeam: number = 0;
  teamUser: any;
  selectedRow: Number | undefined;
  isHover = false;
  teamMemberImageURL: any;
  IsActiveSearch = false; 
  keyword = 'teamMemberName';
  userByEmailResponse: any = [];
  userId: any;
  teamId: string | undefined | null;
  UserIdForUpdateTeamHeader: string | undefined | null;
  teamName: any;
  userByEmailLength: any;
  clientId: string | undefined;
  loCurrentUserData: any;
  ViewclientId: any;
  loCurrentUserRoleData: any;
  btnDisabled = true;
  isDisabled = false;
  isDisabledButton = false; // Disable button when client status is pending approval
  isResponseExist = false;
  LoadingDataMessage = "Getting data..."
  selectedRowForArrow: any;
  isClientActive : any;
  options :any = [];
  availbelOptions :any = [];
 selectedOptions = new FormControl(this.options);
 @ViewChild('selectRef') selectRef!: MatSelect;
  @Input() isWebPageToggleEnabled: boolean = false;
 selectedTeamMembersMap: { [key: number]: string[] } = {}; // Map for selected team members by teamId



  constructor(
    private _Router: Router,
    private renderer: Renderer2,
    private _notificationService: NotificationService,
    private _modalService: NgbModal,
    private spinner: NgxSpinnerService,
    private _teamService: TeamService,
    private config: NgbModalConfig,
    private _userService: UserService,
    private _querystring: ActivatedRoute,
    private _dataService: DatatransferService,
    private _clientService: ClientService,
    private _modulesService : ModulesService,
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef,
   )
   {
    config.backdrop = 'static';
    config.keyboard = false;
    // Security hotfix HF-03 (FE-5): copy the shared request so other screens' values do not leak in
    this.listingBodyParameter = { ...commonConstant.listingBodyParameterForTeam };
    this.listingBodyParameter.stSortColumn = 'stName';
    this.listingBodyParameter.stSortOrder = 'desc';
    this.listingBodyParameter.stSearchText = '';
    this.perPageArray = commonConstant.perPageArray;
    this.loCurrentUserData = JSON.parse(localStorage.getItem('currentUserData') || '{}');
    this.loCurrentUserRoleData = JSON.parse(localStorage.getItem('LoggedInRole') || '{}');


    // for user lising parameters 
    this.listingBodyParameterforUserListing = commonConstant.listingBodyParameterForUser;
    this.listingBodyParameterforUserListing.stSearchText = '';
    this.listingBodyParameterforUserListing.stSortColumn = 'dtUpdatedOn';
   
    this.teamMemberForm =  this.fb.group({
      teamMembers: this.fb.array([]), // Use a FormArray for dynamic teams
    });

    this._dataService.teamListUpdateMessage.subscribe(isTeamListUpdate => {
      if(isTeamListUpdate) {
        this.getRoleByRoleId();
      }
    });
  }
  isLoading: boolean = true; 
  ngOnInit(): void {
    document.body.classList.remove('client-page','add-user-page','add-team-page');
    document.body.classList.add('team-list-page');
    this.getRoleByRoleId();
    setTimeout(() => this.totalTeam = 0, 0);
    this._dataService.teamMemberMessage.subscribe(TeamMemberData => {
    this.spinner.show();
      if (TeamMemberData != "" && TeamMemberData != null && TeamMemberData != undefined) {
        this.userByEmailResponse = [...TeamMemberData];  // Ensures a new reference if needed
        this.userByEmailLength = this.userByEmailResponse.length;
        this.filterTeamMember = [...TeamMemberData];
        console.log( this.filterTeamMember);
        this.cdr.detectChanges();
        this.spinner.hide();
      }
    });
    this._dataService.teamLisingMessage.subscribe(TeamData => {
      if (TeamData != "" && TeamData != null && TeamData != undefined) { 
        this.teamResponse = [];
        this.teamResponse = TeamData;
        this.filterTeamData(TeamData);
        this.isResponseExist = true;
        this.isLoading = false;
      }
    });
    console.log( this.filterTeamMember);
  }

  trackByTeamMember(index: number, teamMember: any): number {
    return teamMember.teamMemberId; // Unique identifier
  }

  getDisplayEmail(email: string): string {
    if (!email) return '';
    const emails = email.split(',').map((e: string) => e.trim()).filter((e: string) => e);
    if (emails.length > 3) {
      return emails.slice(0, 3).join(', ') + ' ...';
    }
    return emails.join(', ');
  }
  
  filterTeamData(TeamData: any) {
    if (TeamData && Array.isArray(TeamData) && TeamData.length > 0) {
        this.combinedTeamData = [];

        TeamData.forEach((team: any) => {
      let selectedMemberIds: any[] = [];
  
      team.teamMembersDetails.forEach((teamMember: any) => {
        this.filterTeamMember.forEach((allTeamMembers: any) => {
          allTeamMembers.isShow = true;
          if (allTeamMembers.teamMemberName === teamMember.name) {
            //selectedMemberIds.push(allTeamMembers.teamMemberId);
          }
        });
      });
  
      let filteredTeam = {
        teamId: team.teamId,
        name: team.name,
        email: team.email,
        teamMembers: team.teamMembers,
        totalRecords: team.totalRecords,
        teamMembersInfo: team.teamMembersInfo,
        teamMembersDetails: team.teamMembersDetails,
        filterTeamMember: [...this.filterTeamMember], // Ensure independent copy
        options: [...selectedMemberIds],  // Copy selected IDs
        selectedOptions: new FormControl([...selectedMemberIds])  // Properly initialize FormControl
      };
  
      this.combinedTeamData.push(filteredTeam);
        });
    }
  }

  onDropdownOpen(isOpened: boolean): void {
    if (isOpened) {
      const overlayPane = document.querySelector('.cdk-overlay-pane') as HTMLElement;
      const customoverlaypanel = document.querySelector('.custom-overlay-panel') as HTMLElement;
  
      // Hide dropdown temporarily
      if (overlayPane) {
        overlayPane.style.visibility = 'hidden';
        customoverlaypanel.style.visibility = 'hidden';
      }
  
      // Wait a bit for the dropdown to render and adjust its position
      setTimeout(() => {
        this.adjustDropdownPosition(this.selectRef); // Adjust the position
  
        // Now, show the dropdown after position is set
        if (overlayPane) {
          overlayPane.style.visibility = 'visible';
          customoverlaypanel.style.visibility = 'visible'; // Show the dropdown
        }
        this.adjustDropdownHeight();
      }, 100); // Adjust the delay based on your app's rendering speed
    }
  }
  adjustDropdownPosition(select: MatSelect) {
    setTimeout(() => {
      const referenceDiv = document.getElementById('multi-team');
      if (!select || !referenceDiv) {
        console.error('MatSelect or referenceDiv is undefined');
        return; // Exit if select or referenceDiv is undefined
      }

      const boundingboxclass = document.querySelector('.cdk-overlay-connected-position-bounding-box') as HTMLElement;
      if(boundingboxclass)
      {
        boundingboxclass.classList.add('custom-overlay-class');
      }

      const overlayPane = document.querySelector('.cdk-overlay-pane') as HTMLElement;
      if (overlayPane) {
        const rect = referenceDiv!.getBoundingClientRect(); // Get the position of the reference div

        // Set the left position
        overlayPane.style.left = `${rect.left}px`;
        overlayPane.style.right = `${rect.right}px`;
        overlayPane.style.marginLeft= `23px`;
      } else {
        console.warn('Overlay pane not found');
      }
    });
  }
    
    
  // Convenience for easy access to form fields
  get TeamMembergetter() {
    return this.teamMemberForm.get('teamMembers') as FormArray;
  }

  // filterTeamMemberInfo(event: any) {
  //   const searchValue = event.target.value.toLowerCase();
  //   console.log("searchValue : ",searchValue)
  //   this.filterTeamMember = this.userByEmailResponse.map((teamMember: any) => ({
  //     ...teamMember, // Clone the object
  //     isShow: teamMember.teamMemberName.toLowerCase().includes(searchValue)
  //   }));
  //   this.getTeamDetails();
  // }

  filterTeamMemberInfo(event: any, item: any, i: number) {
    const searchValue = event.target.value.toLowerCase();
    item.filterTeamMember = this.combinedTeamData[i].filterTeamMember.map((teamMember: any) => ({
      ...teamMember,
      isShow: teamMember.teamMemberName.toLowerCase().includes(searchValue)
    }))    
    this.cdr.detectChanges();
  }

  toggleOption(teamId: number,options:any) {
    // let selectedData = this.teamMemberForm.controls['teamMember'].value;
   
    // Check if teamId already exists in the selectedTeamMembers object
    if (!this.options.includes(teamId) && !this.selectedTeamMembers.includes(teamId)) {
      this.selectedTeamMembers.push(teamId);
      options.push(teamId);
    } 
    this.teamMemberForm.get('teamMember')?.setValue(options.length ? options : []);
  }

    getRoleByRoleId() {
      this.spinner.show();
      this.cdr.detectChanges();
      this.isClientActive = localStorage.getItem('isClientActive');
      if(this.isClientActive == 'Pendingapproval'){
        this.isDisabledButton = true;
      }
      else{
        this.isDisabledButton = false;
      }
      this._modulesService.getRoleByRoleId(this.loCurrentUserData.roleId).subscribe(
        {
          next: (response: any) => {
            if (!!response) {
              if (response.statusCode == 200) {
                this._dataService.sendDataBetweenComponentsForUpdateTeamList(false);
                if (response.data.role.name.toLowerCase() == "client admin") {
                  this.listingBodyParameter.uiClientId = this.loCurrentUserData.clientId;
                  this.ViewclientId = this.loCurrentUserData.clientId;
                  if (document.querySelector('a[href="/parameters"]') != null) {
                    document.querySelector('a[href="/parameters"]')?.setAttribute('class', 'active');
                  }
                }
                else {
                  // Security hotfix HF-03 (FE-5): without a client in the route, use the user's own
                  const routeClientId = this._querystring.snapshot.paramMap.get('clientId');
                  this.listingBodyParameter.uiClientId = routeClientId || this.loCurrentUserData.clientId;
                  this.ViewclientId = routeClientId || this.loCurrentUserData.clientId;
                }
                of(1).pipe(
                  concatMap(() => new Observable(observer => this.getUserByEmail(() => {observer.next(); observer.complete();}))),
                  concatMap(() => new Observable(observer => this.getTeamDetails(true, () => {observer.next(); observer.complete();}))),
                  ).subscribe({
                      complete: () => {
                        this.spinner.hide();
                      }
                    });
              }
            }
          },
          error : (error) => {
            this._dataService.sendDataBetweenComponentsForUpdateTeamList(false);
            // Security hotfix HF-03 (FE-5): without a client in the route, use the user's own
            const routeClientId = this._querystring.snapshot.paramMap.get('clientId');
            this.listingBodyParameter.uiClientId = routeClientId || this.loCurrentUserData.clientId;
            this.ViewclientId = routeClientId || this.loCurrentUserData.clientId;
            this.getUserByEmail(() => {
              this.getTeamDetails(true);
            })
          }
        });  
    }
  
    RemoveFilter(event:any){
      if ((event.key === 'Delete' || event.key==='Backspace') && event.target.value.length === 0 ) {
        this.ClearFilter();
      }
    }
  
    ClearFilter() {
      this.listingBodyParameter.stSearchText = "";
      this.IsActiveSearch = false;
      this.getTeamDetails();
    }
    
    ActiveSearch() {
      this.IsActiveSearch = !this.IsActiveSearch; //true;
      if (!this.IsActiveSearch) {
        if (this.listingBodyParameter.stSearchText != "") {
          this.IsActiveSearch = false;
          this.getTeamDetails();
        }
      }
    }

   getTeamDetails(setTeamList?: boolean, callback?: () => void) {
      this.LoadingDataMessage = "Getting data..."
      this.spinner.show();
      this.listingBodyParameter.teamId = null;
      this._teamService.getTeams(this.listingBodyParameter).subscribe(
        {
          next:  (response) => {
            if (!!response) {
              if (response.statusCode == 200) {
                this.loCurrentUserData = JSON.parse(localStorage.getItem('currentUserData') || '{}');
                this.spinner.hide();
                this.teamResponse = [];
                this.combinedTeamData =[];
                this.teamResponse = response.data.resultSet;
                // Clear selectedTeamMembers object before adding new data
                this.selectedTeamMembers = [];
                  if(response.data.resultSet.length > 0){
                // Iterate over teamResponse to extract team members' names
                this.teamResponse.forEach((team: any, i: any) => {
                    team.teamMembersDetails.forEach((teamMember: any) => {
                        // If the teamName doesn't exist in selectedTeamMembers, initialize it as an empty array
                        if (!this.selectedTeamMembers[team.name]) {
                            this.selectedTeamMembers[team.name] = [];
                        }
                        // Add the team member's name to the respective team
                        this.selectedTeamMembers[team.name].push(teamMember.name);
                    });
                });
               
                  this.filterTeamData(response.data.resultSet);
                this.selectedOptions = new FormControl(this.options);
                if(setTeamList) {
                  this._dataService.sendDataBetweenComponentsForTeamListing(response.data.resultSet);
                } 
              }              
                setTimeout(() => {
                  if (this.teamResponse && this.teamResponse.length) {
                    this.isResponseExist = true;
                    this.totalTeam = this.teamResponse[0].totalRecords;
                  }
                }, 900);
                setTimeout(() => {
                  this.loaded.emit(); // Notify parent when loaded
                }, 1000);
              }
            }
            if(callback) callback();
          },
          error: (error) => {
            this.LoadingDataMessage = "No data found"
            this.spinner.hide();
            this.teamResponse = {
              resultSet: []
            };
            this._dataService.sendDataBetweenComponentsForTeamListing(this.teamResponse);
            this.isResponseExist = false;
            setTimeout(() => this.totalTeam = 0, 0);
            if (error.status == 0) {
              this._notificationService.showError(error.message, 'Error'); // unknown error
            } else if (error.status == 500) {
              this._notificationService.showError("Internal server error.", 'Error');
            }
            if(callback) callback();
          }
        });
    }
  
    onSelectionChange(event: MatSelectChange,options:any) {
      const newlySelected = event.value.filter((id:any) => !options.includes(id)); 
      const deselected = options.filter((id:any) => !event.value.includes(id));
    
      if (deselected.length > 0) {
        this.deselectedUserIds = deselected;
      }
      this.selectedTeamMembers = event.value;
    }

    getUserByEmail(callback?: () => void) {
      let clientId = this.ViewclientId; 
      let searchText = ""
      this.spinner.show();
      this._teamService.getUserByEmail(clientId, searchText).subscribe(
        {
          next:  (response) => {
            if (!!response) {
              if (response.statusCode == 200) {
                //this.spinner.hide();
                this.userByEmailResponse = [];
                this.userByEmailResponse = response.data.users;
                this.userByEmailLength = this.userByEmailResponse.length;
                this.filterTeamMember = [...this.userByEmailResponse];
                this.filterTeamMember = this.userByEmailResponse;
                this.filterTeamMember.forEach((allTeamMembers: any) => {
                  allTeamMembers.isShow = true;
                })
              }
            }
            if (callback) callback();
          },
          error:  (error) => {
            this.spinner.hide();
            this.userByEmailResponse = {
              resultSet: []
            };
            if(callback) callback();
          }
        });
    }
  
//toggleOption1(id: string) {
//  if (id === 'all') {
//    this.isSelectedAll = !this.isSelectedAll;

//    if (this.isSelectedAll) {
//      this.selectedTeamMembers = this.userByEmailResponse.map((team:any) => team.teamMemberId);
//      this.btnDisabled = false;
//    } else {
//      this.selectedTeamMembers = [];
//      this.btnDisabled = true;
//    }

//    this.markedAsChecked(this.isSelectedAll);
//  } else {
//    const index = this.selectedTeamMembers.indexOf(id);
//    if (index > -1) {
//      this.selectedTeamMembers.splice(index, 1);
//      if(this.selectedTeamMembers.length > 0) {
//        this.btnDisabled = false;
//      }else{
//        this.btnDisabled = true;
//      }
//    } else {
//      this.selectedTeamMembers.push(id);
//    }

//    this.isSelectedAll = this.selectedTeamMembers.length === this.userByEmailResponse.length;

//    this.markedAsChecked(this.isSelectedAll);
//  }
//}
    
    markedAsChecked(isChecked: boolean) {
      if (isChecked) {
        this.renderer.addClass(this.checkAllSelectOptions.nativeElement.firstChild, 'mat-pseudo-checkbox-checked');
      } else {
        this.renderer.removeClass(this.checkAllSelectOptions.nativeElement.firstChild, 'mat-pseudo-checkbox-checked');
      }
    }
    
    openDropdown(select: MatSelect) {
      select.open();
    }
   
    //// Selected user - auto complete
    selectEvent(item:any, teamId: any, teamName:any) {
      this.btnDisabled = false;
      this.userId = item.teamMemberId;
      this.teamId = teamId;
      this.teamName = teamName;
    }

    getUserTeam(){
      this._userService.GetUserTeamByUserId(this.loCurrentUserData.userId).subscribe({
        next: (response) => {
          if (!!response) {
            if (response.userTeams != null && response.userTeams.length > 0) {
              // Split the teamId string into an array
              if(this.loCurrentUserData.teamId != null && this.loCurrentUserData.teamId != ""){
              const teamIds = this.loCurrentUserData.teamId.toLowerCase().split(',');            
              
              var updateCurrentUserData = JSON.parse(localStorage.getItem('currentUserData') || '{}');

              // Initialize teamDetails array if it doesn't exist
              if (!updateCurrentUserData.teamDetails) {
                updateCurrentUserData.teamDetails = [];
              }
              
              // Loop through the teams and add each team details to the teamDetails array
              response.userTeams.forEach((team:any) => {
                const teamDetail = {
                  uiTeamId: team.uiTeamId,
                  stName: team.stName
                };
                
                // Only add if not already in the teamDetails array
                if (!updateCurrentUserData.teamDetails.some((existingTeam:any) => existingTeam.uiTeamId === teamDetail.uiTeamId)) {
                  updateCurrentUserData.teamDetails.push(teamDetail);
                }
              });
              
              // Save the updated localStorageData back to localStorage
              localStorage.setItem('currentUserData', JSON.stringify(updateCurrentUserData));
              this._dataService.sendDataBetweenComponents(updateCurrentUserData);
            }
          }
          }
        },
        error: (error) => {
          if (error.status == 0) {
            this._notificationService.showError(error.message, 'Error'); // unknown error
          } else if (error.status == 500) {
            this._notificationService.showError("Internal server error.", 'Error');
          }
        }
      });
    }

    // Add Team member
    addTeamMember(uiTeamId: any, selectedOptions: any, i: number) {
    if(this.selectedMembers.length > 0){
      const teamsMembers = this.combinedTeamData[i].teamMembersDetails.filter(
        (t: { teamId: string }) => t.teamId.split(',')
          .map(id => id.trim().toLowerCase())
          .includes(uiTeamId.trim().toLowerCase())
      );
      const oldSelectedIds: string[] = [];
      const selectedUserIds = selectedOptions.value;
      if (teamsMembers && teamsMembers.length > 0) {
          teamsMembers.forEach((team: { teamId: string, userId: string }) => {
              if (!selectedUserIds.includes(team.userId)) {
                oldSelectedIds.push(team.userId);
              }
          });
      }
      if(oldSelectedIds.length > 0){
        selectedOptions.setValue([...selectedUserIds, ...oldSelectedIds]);
      }
    }
    if (selectedOptions && selectedOptions.value.length > 0) {
      var uiLoggedInUserId = JSON.parse(localStorage.getItem('currentUserData') || '{}').userId;
      if (this.isClientActive == 'Inactive') {
        this._notificationService.showError('Your client has been inactive, please contact to administrator', "Error");
        return;
      }
      this.spinner.show();
      const selectedTeam = this.teamResponse.find((team: any) => team.teamId === uiTeamId);
      this._teamService.addTeamMember(selectedOptions.value.toString(), uiTeamId, uiLoggedInUserId, this.deselectedUserIds.toString()).subscribe(
      {
          next: (response) => {
            if (!!response) {
              if (response.statusCode == 200) {
                this.spinner.hide();
                this._notificationService.showSuccess(response.data, 'Success'); // unknown error
                if (this.userId == uiLoggedInUserId)
                  this._dataService.sendDataBetweenComponentsForTeam({ "message": "addedUser", "teamName": this.teamName, "teamId": this.teamId });

                //update header team details
                this.getUserTeam();

                this.getTeamDetails();
                // this.getUserByEmail();
                this.getUsers(); // for the updating user listing
                this.btnDisabled = true;
              }
            }
              this._teamService.RefreshTeams();
          },
          error: (error) => {
            this.spinner.hide();
            if (error != undefined) {
              if (error.status == 401 && error.statusText == "Unauthorized") {
                this._notificationService.showInfo(commonConstant.expiredSessionErrorMessage, "Information");
              }
            }
            if (error.status == 0) {
              this._notificationService.showError(error.message, 'Error'); // unknown error
            } else if (error.status == 500) {
              this._notificationService.showError("Internal server error.", 'Error');
            }
            else {
              this._notificationService.showError(
                error.error.errorMessage,
                'Error'
              );
            }
          }
        }
      );
    }
    else {
      this._notificationService.showError('Please select at least one team member', "Error");
      return;
    }
  }
  onDropdownClick(event: any) {
    alert('onDropdownClick');
  }
    showModal(content: any, teamId: any, action: any) {
      const overlayPane = document.querySelector('body');
      console.log('overlayPane: ', overlayPane);
      const isClientActive = this.clientStatusValidation();
      if (!isClientActive) {
        return;
      }
      this.isClientActive = localStorage.getItem('isClientActive'); 
      localStorage.setItem('teamAddEditAction', JSON.stringify(action));
      if (teamId == null) {
        this.teamId = undefined;
      }
      if(this.isClientActive == 'Pendingapproval'){
        this.isDisabledButton = true;
       }else{
        this.isDisabledButton = false;
      this._modalService
        .open(content, teamId)
        .result.then(
          (result) => {
            console.log('result: ', result);
          },
          (reason) => {
            console.log('reason: ', reason);
          }
        ).finally(() => {
          document.body.classList.remove('add-team-page');
          document.body.classList.add('team-list-page');
        });
      }
    }
 
    // Remove team member
    removeTeamMember(userId: any, teamId: any) {
      if (!Array.isArray(userId)) {
        userId = [userId];
      }
      if(this.isClientActive == 'Inactive'){
        this._notificationService.showError('Your client has been inactive, please contact to administrator', "Error");
        return;
      } 
      this.spinner.show();
      var count: number = 0;
      userId.forEach((uid: string) => {
        this._teamService.removeTeamMember(uid, teamId).subscribe(
          {
            next:  (response) => {
              if (!!response) {
                if (response.statusCode == 200) {
                  this.spinner.hide();
                  if (userId == JSON.parse(localStorage.getItem('currentUserData') || '{}').userId)
                    this._dataService.sendDataBetweenComponentsForTeam({ "message": "removedUser" });
                  //this._notificationService.showSuccess(response.data, 'Success'); // unknown error
                  count++;
                  if(count === userId.length){
                    this._notificationService.showSuccess(response.data, 'Success');
                  }
                  this.getUserByEmail();
                  this.getTeamDetails();
                  this.getUsers(); // for the updating user listing

                  //update header team details
                  this.getUserTeam();
                }
              }
                this._teamService.RefreshTeams();
            },
            error: (error) => {
              this.spinner.hide();
              if (error != undefined) {
                if (error.status == 401 && error.statusText == "Unauthorized") {
                  this._notificationService.showInfo(commonConstant.expiredSessionErrorMessage, "Information");
                }
              }
              if (error.status == 0) {
                this._notificationService.showError(error.message, 'Error'); // unknown error
              } else if (error.status == 500) {
                this._notificationService.showError("Internal server error.", 'Error');
              }
              else {
                this._notificationService.showError(
                  error.error.errorMessage,
                  'Error'
                );
              }
            }
          }
        );  

      });
      
    }
  
    // Archive user starts
    showArchiveAlert(content: any, teamId: any) {
      this.teamId = teamId;
      this._modalService
        .open(content, { ariaLabelledBy: 'modal-basic-title' })
        .result.then(
          (result) => {
  
          },
          (reason) => {
  
          }
        );
    }
  
    archive(teamId: any) {
      this.spinner.show();
      this._teamService.archiveTeam(teamId).subscribe(
        {
          next: response => {
            if (!!response) {
              this.spinner.hide();
              this.getTeamDetails(true);
              this.hideModal();
              this._notificationService.showSuccess(response.data, "Success");
              // window.location.reload();
              this.getClientDetails();
            }
          }, 
          error: (error) => {
            this.spinner.hide();
             if (error != undefined) {
              if (error.status == 401 && error.statusText == "Unauthorized") {
                this._notificationService.showInfo(commonConstant.expiredSessionErrorMessage, "Information");
              }
            }
            if (error.status == 0) {
              this._notificationService.showError(error.message, "Error"); // unknown error
            } else if (error.status == 500) {
              this._notificationService.showError("Internal server error.", "Error");
            }
            else {
              this._notificationService.showError(error.error.errorMessage, 'Error');
            }
          }
        }
        
        );
    }
    // Archive user ends
  
    // Update team starts
    onUpdateTeam(content: any, teamId: any, action: any, userId: any) {      
      this.teamId = teamId;
      this.UserIdForUpdateTeamHeader = userId;
      this.showModal(content, teamId, action);
    }
    // Update team Ends
  
    // History starts
    getTeamHistory(teamId: any) {
      this._Router.navigate(['/history/' + teamId + '/team']);
    }
    // History ends
  
  
    // Hide Modal
    hideModal() {
      this._modalService.dismissAll("");
    }
    
    onChangeSearch(search: string) {
      if (search == "" || search == null || search == undefined) {
        this.btnDisabled = true;
      }
    }
  
    // Open actions buttons to left
    setClickedRow =  (index: any, isHover: any,i:any) => {      
      // if(isHover){
      //   document.getElementById("teamActionbtn_" + index)?.classList.remove("d-none");        
      // }      
      if(index == -1){  
          document.getElementById("teamActionbtn_" + i)?.classList.add("d-none");
      }
      else{
        document.getElementById("teamActionbtn_" + index)?.classList.remove("d-none");   
      }
      if (this.selectedRow == undefined || index != this.selectedRow || (index == this.selectedRow && !isHover)) {
        this.isHover = true;
        this.selectedRow = index;
        this.isDisabled = true;
      } else if (index == this.selectedRow && isHover) {
        this.isHover = false;
        this.selectedRow = -1;
        this.isDisabled = false;
      }
    }
  
    // Open actions buttons to left
  setClickedRowForArrow =  (index: any) => {
    this.selectedRowForArrow = index;
  }

    pageChanged(event: number) {
      this.listingBodyParameter.inOffset = event - 1;
      this.getTeamDetails();
    }
  
    changePageLimit(pageLimit: any) {
      this.listingBodyParameter.inLimit = parseInt(pageLimit);
      this.getTeamDetails();
    }
  
    getClientDetails() {
      let dt = {
        clientId: this.ViewclientId,
        stSearchText: "",
        stSortColumn: "stClient",
        stSortOrder: "",
        inOffset: 0,
        inLimit: 0
      };
  
      this._clientService.viewClient(dt).subscribe(
        {
          next: (response) => {
            if (!!response) {
              if (response.statusCode == 200) {
                this._dataService.sendDataBetweenComponentsCLientViewPageCounts(response.data.resultSet[0]);
                this.isClientActive = response.data.resultSet[0].isActive;
                if(this.isClientActive == 'Pendingapproval'){
                  this.isDisabledButton = true;
                 }else{
                  this.isDisabledButton = false;
                 }
              }
            }
          },
          error: (error) => {

          }
        }
      );
    }
  
    // for update user listing in dropdown of User/team screen while adding/removing team member from team
    getUsers() {
      this.listingBodyParameter.uiClientId = this.ViewclientId;
      this._userService.getUsers(this.listingBodyParameterforUserListing).subscribe(
        {
          next: (response) => {
            if (!!response) {
              if (response.statusCode == 200) {
                this._dataService.sendDataBetweenComponentsForUserListing(response.data.resultSet);
              }
            }
          },
          error: (error) => {
          }
        } 
      );
    }

    clientStatusValidation() {
        this.isClientActive = localStorage.getItem('isClientActive');
        let expiredDate:any  = localStorage.getItem('currentViewClientExpiryDate');
        const clientExpiredDate = moment(new Date(expiredDate)).format("MM/DD/YYYY");
        const currentDate = moment(new Date()).format("MM/DD/YYYY");
          if((this.isClientActive == 'Inactive') || (new Date(currentDate) > new Date(clientExpiredDate)) && (new Date(currentDate) != new Date(clientExpiredDate))){
            this._notificationService.showError('Client is inactive or expired.', "Error");
            return false;
          }
          return true;
    }

    onExpansionClick(teamId: string, i: number) {
      this.selectedMembers = [];
      this.combinedTeamData[i].filterTeamMember = this.combinedTeamData[i].filterTeamMember.filter((filterMember: any) => {
        return !this.combinedTeamData[i].teamMembersDetails.some((teamMember: any) => {
          return filterMember.teamMemberId === teamMember.userId;
        });
      });
    }

    adjustDropdownHeight(): void {
      const panel = document.querySelector('.mat-select-panel') as HTMLElement;
      const dropdownposition = document.querySelector('.team-list-page .custom-overlay-panel') as HTMLElement;
  
      if (!panel || !dropdownposition) return;
      const viewportHeight = window.innerHeight;
      const dropdownRect = panel.getBoundingClientRect();
      const dropdownTop = dropdownRect.top;
      const spaceBelow = viewportHeight - dropdownTop;
      const spaceAbove = dropdownTop;
      const fixedDropdownHeight = 256; 
      panel.style.maxHeight = `${fixedDropdownHeight}px`;
    
      if (spaceBelow < fixedDropdownHeight && spaceAbove > spaceBelow) {
        dropdownposition.classList.add('opendropdownup');
      } else {
        dropdownposition.classList.remove('opendropdownup'); 
      }
    }

    onSearchKeydown(event: KeyboardEvent): void{
      event.stopPropagation();
   }

    onWebPageToggle(newValue: boolean) {
      this.isWebPageToggleEnabled = newValue;
    }
}